import { Button, Modal } from 'react-bootstrap'
import { useTheme } from '../../context/ThemeContext'
import { FC } from 'react'
import CustomAlert from '../CustomAlert'
import { longWordSlicing } from '../../helper-functions/CheckString'

const DeletePageModal: FC<any> = ({ deletePageMsg, setDeletePageMsg, disableBtn, showPageDelete, handleClose, deletePageHandler, title }: any) => {
    const { theme } = useTheme()
    return (
        <Modal contentClassName={theme === 'dark' ? 'theme__div' : ''} show={showPageDelete} onHide={handleClose} >
            <Modal.Header >
                <Modal.Title className={theme === 'dark' ? 'white__text' : ''}>Delete &ldquo;{longWordSlicing(title)}&ldquo;</Modal.Title>
                <i className={`bi bi-x-lg modal-icon-custom ${theme === 'dark' && 'close'}`} onClick={handleClose}></i>
            </Modal.Header>
            <Modal.Body className={` ${theme === 'dark' ? 'white__text' : ''}`}>
                You are about to permanently delete  &ldquo;{title}&ldquo;. Do you wish to proceed?
            </Modal.Body>
            <Modal.Footer>
                {deletePageMsg.length > 0 ?
                    <CustomAlert
                        className='w-100'
                        variant={'danger'}
                        alertMessage={deletePageMsg}
                        setAlertMessage={setDeletePageMsg}
                        time={4000}
                    />
                    :
                    (<>
                        <Button variant='secondary' onClick={handleClose}>
                            No
                        </Button>

                        <Button variant='primary' onClick={deletePageHandler} disabled={disableBtn}>
                            Yes
                        </Button></>)}
            </Modal.Footer>
        </Modal>
    )
}

export default DeletePageModal